
import { pressReleases as ptPr, PressRelease } from './pressReleases.pt';
import { pressReleasesES as esPr } from './pressReleases.es';

// Press releases não têm versão em inglês; 'en' cai no conteúdo em português.
export const getPressReleases = (lang: string) => lang === 'es' ? esPr : ptPr;
export const pressReleases = ptPr;
export type { PressRelease };
